import { Navigate, Route, Routes } from "react-router-dom";
import { useAuth } from "@/store/auth";
import { useEventsSocket } from "@/hooks/useEventsSocket";
import { useLiveCache } from "@/hooks/useLiveCache";
import { useUnreadTitle } from "@/hooks/useUnreadTitle";
import { AppShell } from "@/components/AppShell";
import { Login } from "@/pages/Login";
import { Workspace } from "@/pages/Workspace";
import { Accounts } from "@/pages/Accounts";
import { Proxies } from "@/pages/Proxies";
import { Workers } from "@/pages/Workers";

export function App() {
  const token = useAuth((s) => s.token);
  const role = useAuth((s) => s.role);

  useEventsSocket();
  useLiveCache();
  useUnreadTitle();

  if (!token) {
    return (
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route element={<AppShell />}>
        <Route path="/" element={<Workspace />} />
        <Route path="/accounts" element={<Accounts />} />
        {role === "admin" && <Route path="/proxies" element={<Proxies />} />}
        {role === "admin" && <Route path="/workers" element={<Workers />} />}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
